<template>
  <div id="app">
    <UiToastList />

    <RouterView :key="$route.path" />

    <portal-target name="backdrop"></portal-target>
  </div>
</template>

<script>
import UiToastList from '@/components/UiToastList'
import { DOMAIN_TITLE } from './.env'

export default {
  components: { UiToastList },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      return title ? `${title} - ${DOMAIN_TITLE}` : `${DOMAIN_TITLE}`
    },
  },
}
</script>
